import Vuex from 'vuex'
import { getUserId,setUserId,getUserName,setUserName, RemoveUserId, RemoveUserName } from '@/utils/auth'


const store = new Vuex.Store({
  state: {
    userId: getUserId(),
    userName:getUserName()
  },
  getters: {
    userId(state){
      return state.userId
    },
    userName(state){
      return state.userName
    }
  },
  //里面定义方法，操作state方发
  mutations: {
    setUserId(state,id) {
      state.userId = id
      setUserId(id)
    },
    setUserName(state,name) {
      state.userName = name
      setUserName(name)
    },
    RemoveUserId(state) {
      state.userId = null
      RemoveUserId()
    },
    RemoveUserName(state) {
      state.userName = null
      RemoveUserName()
    },
    
  },
  // 操作异步操作mutation
  actions: {
    
  },
  modules: {    
  },

})

export default store
